<template>   
     <v-breadcrumbs :items="getBreadCrumbs" divider="-"></v-breadcrumbs>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      
    }
  },
  computed: 
    mapGetters([
                'getBreadCrumbs'
            ])
  ,
  methods: {
  }
}
</script>

<style>

</style>